<script lang="ts">
    import KpPopover from 'shared/ui-widgets/popover/KpPopover.svelte';

    export let additionalPopoverClasses = '';
</script>

<KpPopover buttonSize="md"
           placement="bottom-end"
           buttonStyle="default-viewer-themed"
           additionalPopoverClasses="mv-styled-popover {additionalPopoverClasses}"
           additionalPopoverPanelClasses="mv-styled-popover-panel"
           additionalClasses="mv-styled-popover-button">

    <slot name="button" slot="button"/>

    <span slot="popover-title">
        <slot name="heading"/>
    </span>

    <div slot="popover-content" class="mv-styled-popover-content">
        <slot name="content"/>
    </div>
</KpPopover>

<style lang="less">
    @import (reference) "src/features/media-viewer/media-viewer.variables.less";

    .mv-styled-popover-content {
        padding: @spacing-s 0;
        display: flex;
        flex-direction: column;
    }

    :global {
        .mv-styled-popover {
            .popover {
                background-color: var(--viewer-bg);
            }

            .mv-styled-popover-button {
                height: @media-viewer-topbar-elements-height;
            }

            .popover {
                border-radius: @border-radius-large;
                border: 1px solid var(--viewer-default-border);

                .popover-title {
                    display: flex;
                    align-items: center;
                    height: 42px;
                    font-size: 14.5px;
                    background-color: var(--viewer-content-bg);
                    border-bottom: 1px solid var(--viewer-default-border);
                    border-radius: 0;
                    font-weight: 600;
                }

                .popover-content {
                    background-color: transparent;
                    padding: @spacing-m @spacing-ml;
                    overflow-y: auto;
                    max-height: 400px;
                }
            }
        }

        .mv-styled-popover-panel {
            margin-top: @spacing-s !important;
            margin-left: calc(@spacing-m * -1) !important;
        }
    }
</style>